import { render, staticRenderFns } from "./DowngradePlanModal.vue?vue&type=template&id=71494284"
import script from "./DowngradePlanModal.vue?vue&type=script&lang=js"
export * from "./DowngradePlanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports